var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BoundViewFactory, templateController, ViewSlot } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";
var AnimatableIfCustomAttribute = /** @class */ (function () {
    function AnimatableIfCustomAttribute(viewFactory, viewSlot) {
        this.viewFactory = viewFactory;
        this.viewSlot = viewSlot;
        this.value = true;
        this.bindingContext = null;
        this.overrideContext = null;
        this.view = null;
        this.showing = false;
    }
    AnimatableIfCustomAttribute.prototype.bind = function (bindingContext, overrideContext) {
        this.bindingContext = bindingContext;
        this.overrideContext = overrideContext;
        this.valueChanged(this.value);
    };
    ;
    AnimatableIfCustomAttribute.prototype.valueChanged = function (newValue) {
        var _this = this;
        if (!newValue) {
            var viewOrPromise = void 0;
            if (this.view !== null && this.showing) {
                if (this.funcIn) {
                    if ((this.view.firstChild).classList.contains("au-enter-active")) {
                        (this.view.firstChild).classList.remove("au-enter-active");
                    }
                    this.view.firstChild.removeEventListener("animationend", this.funcIn, false);
                    this.view.firstChild.removeEventListener("animationStart", this.funcAnimationOutStart, false);
                    this.funcIn = null;
                }
                if (this.view && this.view.firstChild.classList.contains("au-enter-active")) {
                    this.view.firstChild.classList.remove("au-enter-active");
                }
                this.funcOut = function () {
                    if (_this.view) {
                        if (_this.view.firstChild.classList.contains("au-leave-active")) {
                            (_this.view.firstChild).classList.remove("au-leave-active");
                        }
                        _this.view.firstChild.removeEventListener("animationend", _this.funcOut, false);
                        _this.view.firstChild.removeEventListener("animationStart", _this.funcAnimationOutStart, false);
                        _this.funcOut = null;
                        viewOrPromise = _this.viewSlot.remove(_this.view, false, true);
                        viewOrPromise.unbind();
                    }
                };
                this.funcAnimationOutStart = function () {
                    clearTimeout(_this.timeoutHandler);
                    _this.view.firstChild.addEventListener("animationend", _this.funcOut, false);
                };
                this.view.firstChild.addEventListener("animationstart", this.funcAnimationOutStart, false);
                if (this.view && this.view.firstChild && !this.view.firstChild.classList.contains("au-leave-active")) {
                    this.view.firstChild.classList.add("au-leave-active");
                }
                clearTimeout(this.timeoutHandler);
                this.timeoutHandler = setTimeout(function () {
                    if (_this.funcOut) {
                        _this.funcOut();
                    }
                }, 800);
            }
            this.showing = false;
        }
        else {
            if (this.funcOut) {
                this.view.firstChild.removeEventListener("animationend", this.funcOut, false);
                this.view.firstChild.removeEventListener("animationStart", this.funcAnimationOutStart, false);
                if (this.view.firstChild.classList.contains("au-leave-active")) {
                    (this.view.firstChild).classList.remove("au-leave-active");
                }
                this.funcOut = null;
                if (this.viewSlot.children.length > 0) {
                    viewOrPromise = this.viewSlot.remove(this.view, false, true);
                    viewOrPromise.unbind();
                }
            }
            if (this.view === null) {
                this.view = this.viewFactory.create();
            }
            if (!this.view.isBound) {
                this.view.bind(this.bindingContext, this.overrideContext);
            }
            if (!this.showing) {
                this.showing = true;
                this.viewSlot.add(this.view);
                if ((this.view.firstChild).classList.contains("au-animate")) {
                    //remove au-enter-active and au-leave-active if in the class already
                    (this.view.firstChild).classList.remove("au-enter-active");
                    (this.view.firstChild).classList.remove("au-leave-active");
                    (this.view.firstChild).classList.add("au-enter-active");
                    var view = this.view;
                    this.funcIn = function () {
                        if ((view.firstChild).classList.contains("au-enter-active")) {
                            (view.firstChild).classList.remove("au-enter-active");
                        }
                        view.firstChild.removeEventListener("animationend", _this.funcIn, false);
                        _this.funcIn = null;
                    };
                    this.view.firstChild.addEventListener("animationend", this.funcIn, false);
                }
            }
        }
    };
    AnimatableIfCustomAttribute.prototype.unbind = function () {
        if (this.view === null) {
            return;
        }
        this.view.unbind();
        if (this.funcOut && !this.value) {
            this.view.firstChild.removeEventListener("animationend", this.funcOut, false);
            if (this.view.firstChild.classList.contains("au-leave-active")) {
                (this.view.firstChild).classList.remove("au-leave-active");
            }
            this.funcOut = null;
            if (this.viewSlot.children.length > 0) {
                var viewOrPromise = this.viewSlot.remove(this.view, false, true);
                viewOrPromise.unbind();
            }
        }
        if (!this.viewFactory.isCaching) {
            return;
        }
        if (this.showing) {
            this.showing = false;
            this.viewSlot.remove(this.view, true, true);
        }
        this.view.returnToCache();
        this.view = null;
    };
    ;
    AnimatableIfCustomAttribute = __decorate([
        autoinject(),
        templateController(),
        __metadata("design:paramtypes", [BoundViewFactory, ViewSlot])
    ], AnimatableIfCustomAttribute);
    return AnimatableIfCustomAttribute;
}());
export { AnimatableIfCustomAttribute };
